import { cn } from '@/utils/cn';

import { getAssigneeColor } from '../task-utils';

interface TaskAssigneeAvatarProps {
    guid: string;
    initials: string;
    className?: string;
}

export const TaskAssigneeAvatar = ({ guid, initials, className }: TaskAssigneeAvatarProps) => (
    <div
        className={cn(
            'flex shrink-0 items-center justify-center rounded-full text-[10px] font-medium text-gray-700',
            className,
        )}
        style={{ backgroundColor: getAssigneeColor(guid) }}
        title={initials}
    >
        {initials}
    </div>
);
